import { configureStore } from '@reduxjs/toolkit';
import userReducer from './slice/userSlice';
import globalReducer from './slice/globalSlice';

const store = configureStore({
  reducer: {
    user: userReducer,
    global: globalReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: ['persist/PERSIST'],
      },
    }),
});

export default store;
